import Cookies from 'universal-cookie';
import { USER_PRIVACY_COOKIE_NAME, DEFAULT_FIXED_HEADER_HEIGHT } from './Constants';

const cookies = new Cookies();

export const getAccountLinkUrlByDomain = (envAccountDomain = false, route = '') =>
  envAccountDomain ? `${envAccountDomain}${route}` : route;

const scrollToWindow = (top = 0) => {
  window.scrollTo({
    top: top,
    behavior: 'smooth',
  });
};

export const scrollToElement = (el, offSetHeight = 0) => {
  if (el) {
    const top = el.getBoundingClientRect().top;
    const scrollToHeight = top - DEFAULT_FIXED_HEADER_HEIGHT - offSetHeight;
    scrollToWindow(scrollToHeight);
  }
};

export const scrollToElementWithDelay = (el, delay = 0, offset = 0) => {
  return setTimeout(() => scrollToElement(el, offset), delay);
};

export const scrollByElementClientHeight = (targetEl) => {
  const heroHeight = targetEl && targetEl.clientHeight - DEFAULT_FIXED_HEADER_HEIGHT;
  scrollToWindow(heroHeight);
};

export const setUserPrivacyCookie = (val = '') => {
  cookies.set(USER_PRIVACY_COOKIE_NAME, val, { path: '/' });
};

export const isEmptyObj = (object) => Object.keys(object).length === 0;

//has a truthy value
export const hasAValue = (object) => {
  let result = false;
  const values = Object.values(object);
  for (let i = 0; i < values.length; i++) {
    if (values[i]) {
      result = true;
      break;
    }
  }
  return result;
};

export const classCombine = (...classList) => {
  let classString = '';

  classList.forEach((className) => {
    if (className) {
      classString += ` ${className}`;
    }
  });
  const trimmedString = classString.substring(1);
  return trimmedString;
};
